import { ClassProvider, inject, Injectable, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";

function describeDestroyService() {
   @Injectable()
   class DestroyService
      extends Subject<void> implements OnDestroy {
         ngOnDestroy() {
            this.next();
            this.complete();
         }
      }

      function provideDestroyService(): ClassProvider {
         return {
            provide: DestroyService,
            useClass: DestroyService,
         };
      }

      function injectDestroyService(): Observable<void> {
         const destroy$ = inject(DestroyService, { self: true, optional: true });
         if (!destroy$) {
            throw new Error("Destroy service not found at providers. Try to add 'provideDestroyService()' to providers");
         }

         return destroy$.asObservable();
      }

      return {
         provideDestroyService,
         injectDestroyService,
      };
}

export const { provideDestroyService, injectDestroyService } = describeDestroyService();
